import { HttpAuthRepository } from "../repositories/auth.repository";

export const authContainer = {
	repository: new HttpAuthRepository(),
} as const;
